VjsAdmin.UserForm4 = (function () {
    const init = function () {
        $('#user_license_ids').multiselect();

        $('#user_role_ids').multiselect({
            onChange() {
                checkRole();
            },
        });
    };

    const checkRole = function () {
        const roleIds = $('#user_role_ids').val();
        if (!roleIds) {
            return;
        }
        if (roleIds.includes('student')) {
            $('#grade_id').closest('.form-group').show();
        } else {
            $('#grade_id').closest('.form-group').hide();
        }

        if (roleIds.includes('api')) {
            $('#user_license_ids').closest('.form-group').hide();
        } else {
            $('#user_license_ids').closest('.form-group').show();
        }
    };

    return {
        init,
    };
}());
